/* Integrates the branded basket with the theme's existing product forms. */
(() => {
  const install = async () => {
    await customElements.whenDefined('cart-drawer');
    await customElements.whenDefined('sw-basket');
    const drawer=document.querySelector('cart-drawer.swd');
    if(!drawer || drawer.swDrawerReady) return;
    drawer.swDrawerReady=true;
    drawer.open=function(trigger,refresh=true) {
      if(trigger instanceof HTMLElement) this.activeElement=trigger;
      else if(refresh && !this.classList.contains('active')) this.activeElement=document.activeElement;
      if(!this.classList.contains('active')) {
        this.previousOverflow=document.body.style.overflow;
        this.inertSiblings=[...document.body.children].filter(element=>element instanceof HTMLElement&&!element.contains(this)&&!['SCRIPT','STYLE','LINK'].includes(element.tagName)&&!element.matches('.restock-rocket-wrapper')&&!element.querySelector('#preorderContainer')).map(element=>[element,element.inert]);
        this.inertSiblings.forEach(([element])=>{element.inert=true;});
      }
      this.inert=false;this.setAttribute('aria-hidden','false');
      this.classList.add('active','animate');
      document.body.style.overflow='hidden';
      document.getElementById('cart-icon-bubble')?.setAttribute('aria-expanded','true');
      this.querySelector('[data-drawer-close]').focus({preventScroll:true});
      if(refresh) this.querySelector('sw-basket').sync();
    };
    drawer.close=function() {
      this.classList.remove('active');this.setAttribute('aria-hidden','true');this.inert=true;
      if(this.previousOverflow!==undefined) document.body.style.overflow=this.previousOverflow;
      document.body.classList.remove('overflow-hidden');
      this.inertSiblings?.forEach(([element,inert])=>{element.inert=inert;});
      this.inertSiblings=null;
      document.getElementById('cart-icon-bubble')?.setAttribute('aria-expanded','false');
      if(this.activeElement?.isConnected) this.activeElement.focus({preventScroll:true});
    };
    drawer.renderContents=async function(data,skipOpen=false) {
      const basket=this.querySelector('sw-basket');
      basket.setBusy(true);
      try { await basket.render(data); }
      catch(error) {basket.error(error.message);}
      finally {basket.setBusy(false);}
      if(!skipOpen) this.open(undefined,false);
    };
    drawer.addEventListener('click',event=>{if(event.target.closest('[data-drawer-close]')||event.target.id==='CartDrawer-Overlay') drawer.close();});
    drawer.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();event.stopPropagation();drawer.close();return;}
      if(event.key!=='Tab') return;
      const controls=[...drawer.querySelectorAll('a[href],button,input,select,summary,[tabindex="0"]')].filter(element=>!element.disabled&&element.getClientRects().length&&getComputedStyle(element).visibility!=='hidden');
      const first=controls[0],last=controls[controls.length-1];
      if(event.shiftKey && (document.activeElement===first||!drawer.contains(document.activeElement))){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    });
    let adding=false;
    document.addEventListener('submit',async event=>{
      const form=event.target;
      if(!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\.js)?$/.test(new URL(form.action,location.href).pathname)) return;
      if(event.submitter?.name==='checkout') return;
      event.preventDefault();event.stopImmediatePropagation();
      if(adding) return;
      adding=true;
      const submitter=event.submitter;
      const originalLabel=submitter?.textContent;
      const data=new FormData(form);
      data.set('sections','cart-drawer,cart-icon-bubble');
      data.set('sections_url',location.pathname);
      if(submitter){submitter.disabled=true;submitter.textContent='Adding to basket…';}
      form.querySelector('[data-sw-add-error]')?.remove();
      drawer.setActiveElement(submitter || form);
      try {
        const response=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'},credentials:'same-origin'});
        const result=await response.json();
        if(!response.ok) throw new Error(result.description || result.message || 'This selection could not be added. Please check your options.');
        await drawer.renderContents(result);
      } catch(error) {
        const message=document.createElement('p');message.dataset.swAddError='';message.setAttribute('role','alert');message.textContent=error.name==='TimeoutError' ? 'We could not confirm the update. Open your basket to check before trying again.' : error.message;form.append(message);
      } finally {adding=false;if(submitter){submitter.disabled=false;submitter.textContent=originalLabel;}}
    },true);
    document.addEventListener('keydown',event=>{
      if(event.defaultPrevented || !drawer.classList.contains('active') || drawer.contains(event.target)) return;
      if(event.target.closest?.('.restock-rocket-wrapper')) return;
      if(event.key==='Escape'){event.preventDefault();drawer.close();}
      if(event.key==='Tab'){event.preventDefault();drawer.querySelector('[data-drawer-close]').focus();}
    });
    document.addEventListener('click',event=>{
      const trigger=event.target.closest('#cart-icon-bubble');
      if(!trigger)return;
      event.preventDefault();event.stopImmediatePropagation();drawer.open(trigger);
    },true);
    document.addEventListener('keydown',event=>{
      if(event.target.id==='cart-icon-bubble' && (event.key==='Enter'||event.key===' ')){
        event.preventDefault();event.stopImmediatePropagation();drawer.open(event.target);
      }
    },true);
    const cartIcon=document.getElementById('cart-icon-bubble');
    cartIcon?.setAttribute('aria-expanded','false');
    cartIcon?.setAttribute('aria-controls','CartDrawer');
    if(new URLSearchParams(location.search).get('basket_preview')==='1') drawer.open(cartIcon);
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',install,{once:true}); else install();
})();
